import { render, staticRenderFns } from "./emoji.vue?vue&type=template&id=5a659e94&scoped=true&"
import script from "./emoji.vue?vue&type=script&lang=js&"
export * from "./emoji.vue?vue&type=script&lang=js&"
import style0 from "./emoji.vue?vue&type=style&index=0&id=5a659e94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a659e94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a659e94')) {
      api.createRecord('5a659e94', component.options)
    } else {
      api.reload('5a659e94', component.options)
    }
    module.hot.accept("./emoji.vue?vue&type=template&id=5a659e94&scoped=true&", function () {
      api.rerender('5a659e94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/classroom1/components/emoji.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/classroom1/components/emoji.vue
// module id = X1v3
// module chunks = 0